import { Box, Button, Typography } from "@mui/material";
import useColors from "../../../../api/hooks/useColors";
import SvgToIcon from "../../../../icons/SvgToIcon";
import { icons } from "../../../stack/environment/icons/iconExport";
import JiraInteractionManager from "../../../stack/integrations/Jira/JiraInteractionManager";
import { getVulnerabilitySource } from "../utils";

const ExternalLinkButton = ({ href, label }) => {
  const colors = useColors();
  return (
    <Button
      component="a"
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      sx={{
        height: 32,
        padding: "0px 8px",
        borderRadius: "10px",
        border: `1px solid ${colors.enabled_stroke}`,
        backgroundColor: colors.common_white,
        textTransform: "none",
        display: "flex",
        gap: 1,
        alignItems: "center",
        "&:hover": {
          backgroundColor: colors.grey_8percent,
        },
      }}
    >
      <Typography variant="overline" color={colors.text_primary}>
        {label}
      </Typography>
      <SvgToIcon IconLogo={icons.ExternalLinkIcon} width="14px" />
    </Button>
  );
};

const VulnerabilityQuickActions = ({ selectedVulnerability }) => {
  if (!selectedVulnerability) return null;

  const { sourceURL } = getVulnerabilitySource(
    selectedVulnerability?.vulnerability_id
  );

  return (
    <Box display="flex" flexDirection="column" gap={1}>
      <Typography variant="subtitle2">Quick Actions</Typography>
      <Box display="flex" gap={1} alignItems="center">
        <JiraInteractionManager
          vulnerability={selectedVulnerability}
          sx={{
            height: 32,
          }}
          hideTitle
          hideTooltip={false}
        />
        {selectedVulnerability.qualys_deep_link && (
          <ExternalLinkButton
            href={selectedVulnerability.qualys_deep_link}
            label="QID in Qualys"
          />
        )}
        {sourceURL && <ExternalLinkButton href={sourceURL} label="NIST" />}
      </Box>
    </Box>
  );
};

export default VulnerabilityQuickActions;
